import { kebabCase } from 'lodash-es';
import Link from 'next/link';
import React, { MouseEventHandler } from 'react';

import { JOBS_ROUTE } from './constants';
import { AccordionItemProps } from './types';

const RelatedLocations: React.FC<Pick<AccordionItemProps, 'relatedLocations' | 'translatedJobTitle'>> = ({
  relatedLocations,
  translatedJobTitle,
}) =>
  relatedLocations?.length
    ? relatedLocations?.map((location, index) => (
        <React.Fragment key={location}>
          <Link
            className='text-primary hover:underline'
            href={`${JOBS_ROUTE}/${[kebabCase(translatedJobTitle), kebabCase(location)].filter(Boolean).join('/')}`}
            onClick={stopPropagation}>
            {location}
          </Link>
          {index !== relatedLocations.length - 1 && ', '}
        </React.Fragment>
      ))
    : null;

const stopPropagation: MouseEventHandler<HTMLAnchorElement> = event => {
  event.stopPropagation();
};

export default RelatedLocations;
